export const PreviewType = {
  Image: 'image',
  Video: 'video',
  File: 'file',
  Auto: 'auto',
};
